export default "__VITE_ASSET__DIeewsPr__"